
export const ROUTER_EDITEAZA_VEHICULE = {
  routes: ["/", "/logs", "*"],
};

export const VEHICLE_OPTIONS_DUPLICATE_VEHICLE = {
  duplicateVehicle: true,
};
